module.exports = __webpack_public_path__ + "img/chineseBanner1.cf6f8f09.png";